export default __webpack_public_path__ + "static/media/DiscordIcon.7d6dd3e4.svg";